import { getLowestItemPrice, isDiscountItemPrice, isMemberRewardItemPrice, isZeroMonetaryValue, logger } from '@vista/omnichannel-components-domain';
import { DiscountCalculationType } from '@vista-digital/ocapi-types/v1';
export const getPromotionLabelForSellableItem = (sellableItem, displayText, i18n, lowestItemPrice) => {
    const lowestPrice = lowestItemPrice || getLowestItemPrice(sellableItem.prices);
    if (!lowestPrice)
        return;
    if (isDiscountItemPrice(lowestPrice))
        return getLabelForDiscountItemPrice(lowestPrice, displayText, i18n);
    if (isMemberRewardItemPrice(lowestPrice))
        return displayText.member.rewardExclusiveLabel;
};
export const getLabelForDiscountItemPrice = (lowestPrice, displayText, i18n) => {
    if (isZeroMonetaryValue(lowestPrice.price))
        return displayText.price.freeDiscountLabel;
    return getLabelByDiscountCalculationType(lowestPrice.discount.calculation, lowestPrice.discount.amountSaved, displayText, i18n);
};
const getLabelByDiscountCalculationType = (discount, amountSaved, displayText, i18n) => {
    switch (discount.type) {
        case DiscountCalculationType.PercentageOff:
            return i18n.template(displayText.price.percentageOffDiscountFormat, {
                discount: discount.percentageOff
            });
        case DiscountCalculationType.PriceOff:
        case DiscountCalculationType.SpecialPrice:
            return i18n.template(displayText.price.priceOffDiscountFormat, {
                discount: i18n.monetaryValue(amountSaved)
            });
        default:
            logger.warn(`Cannot get discount label with unknown discount '${discount}'.`);
            return;
    }
};
